import { createAction, props } from '@ngrx/store';
import { PhoneTypes } from 'generated/graphql-types';
import { SingleGraphError } from 'src/app/common-components/errors/models/error-message';
import { HardphoneDetailSaveModel } from '../models/hardphone-detail-save.model';

export const addPhone = createAction('[Add Phone] Add Hardphone', props<{ hardphoneAdd: HardphoneDetailSaveModel }>());

export const addHardphoneSuccess = createAction('[API] Add Hardphone Success', props<{ phoneType: PhoneTypes }>());

export const addHardphoneFailure = createAction('[API] Ad Hardphone Failure', props<SingleGraphError>());
